module.exports = __webpack_public_path__ + "static/media/Adobe_Acrobat_DC_icon.ea77490f.png";